/**
 * Rotas de desenvolvimento (revisão visual, fora da tabela 3.1):
 * - `/dev/galeria` → `ComponentGallery` (primitivos, domínio e shell, WP0b);
 * - `/dev/graficos` → `ChartsGallery` (todos os gráficos, WP3).
 *
 * Ficam fora do AppShell (cada galeria tem o próprio layout) e são `lazy()`: os dados de
 * exemplo nunca entram no bundle das telas. Só existem no dev server (`vite`): no build de
 * produção `import.meta.env.DEV` vira `false` e os `import()` são eliminados.
 */
import { lazy, type ReactNode, Suspense, useEffect } from 'react';
import { Route } from 'wouter';
import { MAIN_ID } from '@/lib/a11y';
import { appCopy } from './copy';
import { RouteErrorBoundary, RouteLoading } from './RouteStates';

const ComponentGallery = import.meta.env.DEV
  ? lazy(() => import('@/components/Gallery').then((m) => ({ default: m.ComponentGallery })))
  : null;
const ChartsGallery = import.meta.env.DEV
  ? lazy(() => import('@/charts/ChartsGallery').then((m) => ({ default: m.ChartsGallery })))
  : null;

function DevPage({ title, children }: { title: string; children: ReactNode }) {
  useEffect(() => {
    document.title = appCopy.documentTitle(title);
  }, [title]);
  return (
    <RouteErrorBoundary resetKey={title}>
      <Suspense fallback={<RouteLoading />}>{children}</Suspense>
    </RouteErrorBoundary>
  );
}

/** Rotas `/dev/*` (para usar dentro de um `<Switch>`). Vazio fora do dev server. */
export function devRoutes() {
  if (!ComponentGallery || !ChartsGallery) return null;
  return [
    <Route key="galeria" path="/dev/galeria">
      <DevPage title={appCopy.dev.components}>
        <main id={MAIN_ID} tabIndex={-1}>
          <ComponentGallery />
        </main>
      </DevPage>
    </Route>,
    <Route key="graficos" path="/dev/graficos">
      <DevPage title={appCopy.dev.charts}>
        <ChartsGallery />
      </DevPage>
    </Route>,
  ];
}
